import axios, { type AxiosError } from "axios";
import { ErrorToast } from "@core/components/toast/Toast";
import { COMMON } from "@core/constants/messages";
import type { ContiApiErrorType } from "@core/model/errorModel";

export const contiInstance = axios.create({
  baseURL: "/conti/",
  // withCredentials: true,
});

// 응답 인터셉터: 에러 핸들링 공통화
contiInstance.interceptors.response.use(
  (res) => res,
  (err: AxiosError<ContiApiErrorType>) => {
    ErrorToast(COMMON.API_ERROR);

    return Promise.reject(err);
  },
);
